@if (
  !patientSearchData() ||
  (patientSearchData() &&
    (patientSearchData()?.otpStatus === OTPStatuses.Locked ||
      patientSearchData()?.otpStatus === OTPStatuses.Error ||
      patientSearchData()?.otpStatus === OTPStatuses.NotFound))
) {
  <form
    id="cy_search_form"
    name="cy_search_form"
    [formGroup]="searchForm"
    #sfrm="ngForm"
    (ngSubmit)="onFormSubmit(sfrm)"
    class="d-flex flex-column gap-3"
  >
    <div class="row justify-content-lg-center">
      <div class="col-md-6 col-lg-3 col-12">
        <ncp-select [(options)]="searchSelectOptions" />
      </div>
      <div class="col-md-6 col-lg-3 col-12 mt-md-0 mt-3">
        <ncp-input [(options)]="idCardInputOptions" />
      </div>
      <div class="col-md-6 col-lg-3 col-12 mt-3 mt-md-3 mt-lg-0 ">
        <ncp-date [(options)]="dobDateOptions" />
      </div>
      <div class="col-lg-auto col-12 mt-3 mt-lg-0">
        <div
          class="row"
          style="margin-bottom: 8px"
        >
          <br />
        </div>
        <ncp-button [(options)]="searchSubmitButtonOptions" />
      </div>
    </div>
  </form>
} @else if (patientSearchData() && patientSearchData()?.otpStatus === OTPStatuses.AddDemographics) {
  <form
    id="cy_demographics_form"
    name="cy_demographics_form"
    [formGroup]="demographicsForm"
    #dfrm="ngForm"
    (ngSubmit)="onFormSubmit(dfrm)"
    class="d-flex flex-column"
  >
    <div class="row">
      <div class="col-md-8 col-12">
        <ncp-input [(options)]="addressInputOptions" />
      </div>
      <div class="col-md-4 col-12 mt-md-0 mt-3">
        <ncp-input [(options)]="addressNumberInputOptions" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-4 col-12">
        <ncp-input [(options)]="addressPostCodeInputOptions" />
      </div>
      <div class="col-md-4 col-12 mt-md-0 mt-3">
        <ncp-input [(options)]="addressCityInputOptions" />
      </div>
      <div class="col-md-4 col-12 mt-md-0 mt-3">
        <ncp-input [(options)]="addressCountryInputOptions" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6 col-12">
        <ncp-input [(options)]="emailInputOptions" />
      </div>
      <div class="col-md-6 col-12 mt-md-0 mt-3">
        <ncp-input [(options)]="telephoneInputOptions" />
      </div>
    </div>
    <div class="row pt-3 submitButton">
      <ncp-button [(options)]="demographicsSubmitButtonOptions" />
    </div>
  </form>
} @else if (patientSearchData() && patientSearchData()?.otpStatus === OTPStatuses.OTPOk) {
  <div class="d-flex flex-column justify-content-center align-items-center">
    <div class="w-50">
      <form
        id="cy_otp_form"
        name="cy_otp_form"
        [formGroup]="otpForm"
        #ofrm="ngForm"
        (ngSubmit)="onFormSubmit(ofrm)"
        class="d-flex gap-3 justify-content-center"
      >
        <div class="col">
          <ncp-input [(options)]="otpInputOptions" />
        </div>
        <div class="flex-shrink-0">
          <div
            class="row"
            style="margin-bottom: 8px"
          >
            <br />
          </div>
          <ncp-button [(options)]="otpSubmitButtonOptions" />
        </div>
      </form>
    </div>


    <div class="w-50 justify-content-center align-items-start">
      <div class="resend">
        @if(countdown() > 0) {
          {{countdownText()}}
        } @else {
          {{translations.otp_expired}}
        }
        @if (countdown() < 60 && !resendDisabled()) {
          <a
            #resendLink
            [class.link-primary]="!resendDisabled()"
            [class.link-secondary]="resendDisabled()"
            [class.link-underline-opacity-0]="resendDisabled()"
            [class.resend_link]="!resendDisabled()"
            class="link-opacity-75"
            (click)="!resendDisabled() && resendOTP()">{{translations.resend_otp}}</a>
        } @else if(countdown() < 60 && resendDisabled()) {
          <div class="loading spinner-border text-dark resend spinner ms-1" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        }
      </div>
    </div>
  </div>
}

<!--@if (-->
<!--  patientSearchData() &&-->
<!--  (patientSearchData()?.otpStatus === OTPStatuses.Locked ||-->
<!--    patientSearchData()?.otpStatus === OTPStatuses.Error ||-->
<!--    patientSearchData()?.otpStatus === OTPStatuses.NotFound)-->
<!--) {-->
<!--  <ncp-alert [(options)]="errorsAlertOptions"></ncp-alert>-->
<!--}-->

@if (errorsAlertOptions().show) {
  @if(searchFormElement?.form?.errors && Object.keys(searchFormElement?.form?.errors!).length > 0 ||
  demographicsFormElement?.form?.errors && Object.keys(demographicsFormElement?.form?.errors!).length > 0 ||
  otpFormElement?.form?.errors && Object.keys(otpFormElement?.form?.errors!).length > 0
    ) {
    <ncp-alert [(options)]="errorsAlertOptions">
      <alert-body>
        <div class="d-flex flex-column flex-grow-1 mt-2">
          @if(searchFormElement?.form?.errors || demographicsFormElement?.form?.errors || otpFormElement?.form?.errors){
            @for (entry of Object.keys(searchFormElement?.form?.errors || demographicsFormElement?.form?.errors || otpFormElement?.form?.errors || {}); track entry; let i = $index) {
              <div class="error col-12 my-0 py-o fs-6 text-danger"><span>{{i + 1}} - {{translations.validations[entry] || entry}}</span></div>
            }
          }
        </div>
      </alert-body>
    </ncp-alert>
  } @else {
    <ncp-alert [(options)]="errorsAlertOptions"></ncp-alert>
  }
}
